import React, { useState } from 'react';
import { Table, TableHead, TableRow, TableCell, TablePagination, TableSortLabel, styled } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';

export default function useTable(headCells) {

    const pages = [5, 10, 25, 50];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
    const [order, setOrder] = useState();
    const [orderBy, setOrderBy] = useState();

    const TblContainer = (props) => (
        <div className='col-md-12 row mx-auto p-0 mb-0 ' >
            <table className="table table-striped table-hover table-sm border-table my-0">
                {props.children}
            </table>
        </div>
    );

    const TblHead = (props) => {

        const handleSortRequest = (cellId) => {
            const isAsc = orderBy === cellId && order === "asc";
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(cellId);
        };

        return (
            <TableHead>
                <tr>
                    {
                        headCells.map(headCell => (
                            <td
                                key={headCell.id}
                                style={{ width: headCell.width, backgroundColor: 'rgba(5, 81, 130, 1)',
                                fontWeight: 'bold',
                                color: 'white',
                                fontSize: '10px',
                                textAlign: 'center' }}
                                sortDirection={orderBy === headCell.id ? order : false}
                            >
                                {headCell.label}
                                {/* {headCell.disableSorting ? headCell.label :
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : 'asc'}
                                        onClick={() => { handleSortRequest(headCell.id) }}>
                                        {headCell.label}
                                    </TableSortLabel>
                                } */}
                            </td>
                        ))
                    }
                </tr>
            </TableHead>
        );
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const TblPagination = () => (
        <TablePagination
            component="div"
            page={page}
            rowsPerPageOptions={pages}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Filas por Página"
            count={records.length}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    );

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

   

    return {
        TblContainer,
        TblHead,
        TblPagination,
        
    };
}
